import { ServiceInfoType } from 'types/uiTypes';
import { IconTorgetShipping24 as ShippingIcon } from '@fabric-ds/icons/react';
import { Button } from '@fabric-ds/react';
import pulseClient from 'resources/pulse';
import ExpandableDataContainer from './ExpandableDataContainer';
import DottetList from './DottetList';

type Props = {
    serviceInfo: ServiceInfoType;
};

const Content = ({ serviceInfo }: Props) => (
    <div className="my-24 md:my-0">
        <p className="text-gray-700">{serviceInfo.text}</p>
        <DottetList details={serviceInfo.details} />
        <Button className="text-14 font-bold mt-16" link href="/bap/artikler/aktuelt/fiks-ferdig">
            {serviceInfo.actions.moreInfo.text}
        </Button>
    </div>
);

const FiksFerdigInfo = ({ serviceInfo }: Props) => {
    const { title } = serviceInfo;

    return (
        <ExpandableDataContainer
            icon={
                <ShippingIcon
                    role="img"
                    aria-label="Varebil med fartsstriper bak"
                    color="var(--f-gray-500)"
                />
            }
            title={title}
            tracker={pulseClient.trackExpandFiksFerdig}
        >
            <Content serviceInfo={serviceInfo} />
        </ExpandableDataContainer>
    );
};

export default FiksFerdigInfo;
